var locale = {
    locale: 'en-US',
    previous: 'Previous',
    next: 'Next',
    gotIt: 'Got it'
};
export default locale;
